import Backbone from 'backbone';
import templateView from './templateView';

export default Backbone.View.extend({
  initialize(o) {
    this.collection = o.collection;
    this.parent = o.parent;
    this.groups = o.groups;
  },

  getGroupName(model) {
    let group = this.groups.filter(function(group) {
      if (group.id == model.get('group')) {
        return true;
      }
    });
    if (group.length) {
      return group[0].name;
    } else {
      return '';
    }
  },

  addToCollection(model, fragmentEl) {
    var fragment = fragmentEl || null;
    var viewObject = templateView;
    let groupName = this.getGroupName(model);
    model.set('group_name', groupName);
    var view = new viewObject({
      model
    });
    var rendered = view.render().el;
    if (fragment) {
      fragment.appendChild(rendered);
    } else {
      this.$el.append(rendered);
    }
    return rendered;
  },

  render() {
    var fragment = document.createDocumentFragment();
    this.$el.empty();
    this.collection.each(function(model) {
      this.addToCollection(model, fragment);
    }, this);
    this.$el.append(fragment);
    this.$el.addClass('content-templates');
    return this;
  }
});
